import { createContext, useContext } from 'react';

/** Live `#content` node. Work passes it as the file-drop boundary. */
export const ShellContentElementContext = createContext<HTMLElement | null>(null);

export function useShellContentElement(): HTMLElement | null {
  return useContext(ShellContentElementContext);
}
